import routerUtils from "@/router/routerUtils";
import BasisdatenVHV2024 from "@/views/vhv2024/views/BasisdatenVHV2024.vue";
import VergleichVHV2024 from "@/views/vhv2024/views/VergleichVHV2024.vue";
import IhreDatenVHV2024 from "@/views/vhv2024/views/IhreDatenVHV2024.vue";
import AbschlussVHV2024 from "@/views/vhv2024/views/AbschlussVHV2024.vue";
import BestaetigungVHV2024 from "@/views/vhv2024/views/BestaetigungVHV2024.vue";

const { pruefeDatenVorhanden } = routerUtils();

export default [
  {
    path: "",
    name: "VHV2024_Basisdaten_Direkt",
    component: BasisdatenVHV2024,
    meta: {
      title: "Hausratversicherung - Basisdaten | GEV-Versicherung",
    },
  },
  {
    path: "vergleich",
    name: "VHV2024_Vergleichn_Direkt",
    component: VergleichVHV2024,
    meta: {
      title: "Hausratversicherung - Vergleich | GEV-Versicherung",
    },
    beforeEnter: pruefeDatenVorhanden("/vhv", "NEU"),
  },
  {
    path: "ihre-daten",
    name: "VHV2024_IhreDaten_Direkt",
    component: IhreDatenVHV2024,
    meta: {
      title: "Hausratversicherung - Ihre Daten | GEV-Versicherung",
    },
    beforeEnter: pruefeDatenVorhanden("/vhv", "NEU"),
  },
  {
    path: "abschluss",
    name: "VHV2024_Abschluss_Direkt",
    component: AbschlussVHV2024,
    meta: {
      title: "Hausratversicherung - Zusammenfassung und Abschluss | GEV-Versicherung",
    },
    beforeEnter: pruefeDatenVorhanden("/vhv", "NEU"),
  },
  {
    path: "bestaetigung",
    name: "VHV2024_Bestaetigung_Direkt",
    component: BestaetigungVHV2024,
    meta: {
      title: "Hausratversicherung - Vielen Dank | GEV-Versicherung",
    },
    beforeEnter: pruefeDatenVorhanden("/vhv"),
  },
];
